import * as React from "react";

function NoEntry(props) {
  return (
    <svg viewBox="0 0 24 24" width={24} height={24} fill="currentColor" {...props}>
      <path d="M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.22729 1.21447 3.47672 0.608967 4.93853C0.00346629 6.40034 -0.15496 8.00887 0.153721 9.56072C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58225 16 8C15.9977 5.87897 15.1541 3.84547 13.6543 2.34568C12.1545 0.845885 10.121 0.00229405 8 0V0ZM12.3333 8.66667C12.3333 8.75507 12.2982 8.83986 12.2357 8.90237C12.1732 8.96488 12.0884 9 12 9H4C3.9116 9 3.82681 8.96488 3.7643 8.90237C3.70179 8.83986 3.66667 8.75507 3.66667 8.66667V7.33333C3.66667 7.24493 3.70179 7.16014 3.7643 7.09763C3.82681 7.03512 3.9116 7 4 7H12C12.0884 7 12.1732 7.03512 12.2357 7.09763C12.2982 7.16014 12.3333 7.24493 12.3333 7.33333V8.66667Z" fill="#757575"/>
    </svg>

  );
}

export default NoEntry;
